import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }} // Start slightly transparent and lower
      animate={{ opacity: 1, y: 0 }}  // Fade in and move up
      exit={{ opacity: 0, y: -15 }}   // Fade out and move up on exit
      transition={{ duration: 0.4, ease: "easeOut" }} // Smooth timing
      className="w-full"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;